import Radio, { RadioProps } from "@mui/material/Radio";

import style from "./ThumbsIconRadioButton.module.scss";

const ThumbsIconRadioButton = (props: RadioProps) => {
  return (
    <Radio
      className={style.root}
      classes={{ checked: style.checked }}
      disableRipple
      tabIndex={-1}
      {...props}
    />
  );
};

export default ThumbsIconRadioButton;
